export const fetchWithdrawalsAfterDate = (date: string) => ({
  type: 'FETCH_WITHDRAWALS_AFTER_DATE',
  payload: date
}); 